export default function NotFound({lang}) {

    return (
        <div className="page_not_found">
            {lang === "ko" ? (
                <h1>페이지를 찾을 수 없음</h1>
                
            ) : (
                <h1>Page Not Found</h1>
            )}

            {lang === "ko" ? (
                <p>존재하지 않는 페이지에 접속하셨습니다. 홈페이지로 <a href="/ko">돌아가주세요</a></p>
                
            ) : (
                <p>You have reached a page that doesn't exist.  Please return to our <a href="/en">homepage</a></p>
            )}
        </div>
    )
}